module.exports = __webpack_public_path__ + "7466e8cc086c41f76f8a6c71e03839d2.ttf";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Black.ttf
// module id = 653
// module chunks = 0